import React from "react";
import { Modal, Carousel } from "react-bootstrap";
import "./BookModal.css";

const BookModal = ({ book, show, onHide }) => {
  if (!book) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="book-modal"
      aria-labelledby="book-modal-title"
    >
      <Modal.Header closeButton></Modal.Header>

      <Modal.Body>
        <div className="book-modal-carousel-wrapper">
          <Carousel
            controls={book.images.length > 1}
            indicators={book.images.length > 1}
            interval={null}
          >
            {book.images.map((src, idx) => (
              <Carousel.Item key={idx}>
                <div className="book-modal-slide">
                  <img
                    className="book-modal-img"
                    src={src}
                    alt={`${book.title} ${idx + 1}`}
                  />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>

        <div className="book-modal-info">
          {!book.isLive && (
            <span className="book-modal-badge">Coming Soon</span>
          )}
          <h3 id="book-modal-title" className="book-modal-title">
            {book.title}
          </h3>
          <p className="book-modal-description">
            {book.description || book.tagline}
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BookModal;
